import React, { useState, useEffect } from 'react';
import { ReactComponent as DropDownIcon } from '../../assets/svg/drop_down.svg';
import { Color } from '../../enums/Color';

interface FAQ {
    id: number;
    Question: string;
    Answer: string | string[];
}

interface Props {
    FAQs: FAQ[];
    styles: any;
}

export const FAQContent : React.FC<Props> = (props) => {
    const styles = props.styles;
    const [activeQuestion, setActiveQuestion] = useState<number>(); 

    const handleQuestionClick = (id: number) => {
        setActiveQuestion((prevActiveQuestion) => (prevActiveQuestion === id ? undefined : id));
    };

    useEffect(()=>{
        setActiveQuestion(undefined);
    }, [props.FAQs]);

    const renderWithBold = (text: string) => {
        const parts = text.split(/\*\*(.*?)\*\*/g);
        return parts.map((part, index) =>
            index % 2 === 1 ? <strong key={index} style={{ color: Color.Black }}>{part}</strong> : part
        );
    };

    return(
        <>
            {props.FAQs.map((FAQ) => 
                <div key={FAQ.id}>
                    <div style={{...styles.question, ...(activeQuestion === FAQ.id && styles.question.active)}} onClick={() => handleQuestionClick(FAQ.id)}>
                        {FAQ.Question}
                        <div style={styles.iconWrapper}>
                            <DropDownIcon style={{...styles.dropdownIcon, ...(activeQuestion === FAQ.id && styles.dropdownIcon.active)}}/>
                        </div>
                    </div>
                    <div 
                        style={{
                            ...styles.answer,
                            ...(activeQuestion === FAQ.id ? styles.answer.active : styles.answer.inactive)
                        }}
                    >
                        {Array.isArray(FAQ.Answer) 
                            ? FAQ.Answer.map((para, i) => (
                                <p key={i} style={styles.paragraph}>{renderWithBold(para)}</p>
                            )) 
                            : renderWithBold(FAQ.Answer)
                        }
                    </div>
                </div>
            )}
        </>
    )
}